import { ImpactModule } from 'types'
import { ATTENDANCES_PAGES } from './pages'
import { ATTENDANCES_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const ATTENDANCES_MODULE: ImpactModule = {
  NAME: 'attendance',
  NAME_PTBR: 'Atendimentos',
  UPPER_NAME: 'ATTENDANCE',
  API_NAME: 'ATTENDANCE',
  PAGES: ATTENDANCES_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: ATTENDANCES_PAGES_ORDER_FOR_PERMISSIONS,
}
